/*
 * @Description: user actions type
 */

export enum PortalActionTypes {
  ACTION_GET_PORTAL_INFO = 'ACTION_GET_PORTAL_INFO',
}
